<template>
  <a-entity drop-scene>
    <!--todo loading
    <a-torus color="#43A367" arc="270" radius="5" radius-tubular="0.1" />
-->
    <a-entity
      loading
      scale="1 1 1"
      position="0 0 0"
    />
    <!-- polygon -->
    <a-entity
      polygon
      animation-mixer
      scale="1 1 1"
      position="0 0 0"
      rotation="0 0 0"
      env-map="resolution:256;
      repeat: true;
      interval: 50;
      roughness: 0.1;
      metalness: 1.0;
      mat-override:false"
    />
    <!-- Optionally, show a loading or placeholder entity if drop is not ready
    <a-entity v-else loading scale="1 1 1" position="0 0 0" />-->

    <!--      animation="property: rotation; to: 0 360 0; loop: true; dur: 20000; easing: linear;"-->

    <!-- cube player-->
    <a-box
      cube
      visible="false"
      class="clickable"
      material="color: white"
      position="9 11 -11"
      scale="1 1 1"
      depth="2"
      height="2"
      width="2"
      rotation="0 0 0"
      cube-animation="property: rotation; to: 0 360 0; loop: true; dur: 20000; easing: linear;"
    />

    <!-- <a-box
      test
      color="blue"
      class="clickable"
      position="9 11 -11"
      scale="1 1 1"
      depth="2"
      height="2"
      width="2"
      rotation="0 0 0"
    /> -->

    <!-- video -->
    <!-- <a-box class="clickable" height="10" width="16" depth="0" position="10, 6, -11" rotation="0 -10 0" /> -->

    <!--HERE IN LIES THE PROBLEM - preview works when video is missing. the form works when it's there...-->
    <a-video
      id="video"
      visible="false"
      video
      class="clickable"
      width="16"
      height="10"
      rotation="0 -1w0 0"
      position="10, 6, -10"
      src="#video-asset"
      material="transparent: true"
    />

    <PortalAR position="0, 0, 0" />

    <!-- message
    position="-10, 6, -11" rotation="0 10 0" -->
    <a-entity>
      <a-entity id="rewardsContainer" rewards-container />

      <!-- Perhaps try nesting a-text inside a-plane here -->
      <!--removing position="-7.25 4 0" scale="15 15 15"-->
      <a-entity>
        <a-entity
          rewardmessage
        />
        <!-- <a-entity
          rewardmessage
          class="clickable"
          textpadding="padding: .1"
          geometry="primitive: plane; width: auto; height: auto;"
          material="color: white"
          text="color: black; wrapCount: 30; baseline: center; anchor: center;"
          height="10"
          width="16"
          position="'-7.25 4 0'"
          scale="15 15 15"
        /> -->

        <a-entity
          id="rewardPolygon"
          visible="false"
          class="clickable"
          animation-mixer
          position="-7.25 7 -20"
          rotation="0 0 0"
          env-map="resolution:256;
        repeat: true;
        interval: 50;
        roughness: 0.1;
        metalness: 1.0;
        mat-override:false"
        />
      </a-entity>

      <a-entity polygon-attribution text="color: black; wrapCount: 30; baseline: top; anchor: left;" position="-7.25 -3.5 0" scale="6 6 6" />
    </a-entity>

    <!-- capture button moved to Main.vue so it only appears in the AR experience -->
    <div id="overlay" class="absolute-fill">
      <!-- <a id="promptText" href="#" @click="recenter()">re-center</a> -->
      <portal to="destination">
        <b-button id="recenter" class="align-middle border-light bg-transparent btn-circle" @click="recenter()">
          <font-awesome-icon :icon="['fas', 'crosshairs']" style="font-size:30px; vertical-align: middle;" />
          <span style="font-size:14px;">recenter</span>
        </b-button>
      </portal>
    </div>
  </a-entity>
</template>
<script>
import PortalAR from '~/components/portal/PortalAR.vue'
export default {
  components: {
    PortalAR
  },
  methods: {
    recenter (event) {
      debugger
      const mainScene = document.querySelector('[main-scene]')
      mainScene.emit('recenter')
    }
  }
}
</script>
<style scoped>
.btn-circle {
  width: 70px;
  height: 70px;
  padding: 6px 0px;
  border-radius: 35px;
  border-style: none;
  text-align: center;
  font-size: 12px;
  line-height: 1.42857;
}

.absolute-fill {
  z-index: 100;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  pointer-events: none;
}
#recenter {
  position: absolute;
  z-index: 101;
  bottom: 1vh;
  left: 1%;
}
#promptText {
  font-size: 6vw;
  text-align: left;
  color: white;
  text-shadow: 2px 2px 8px black;

  position: absolute;
  width: 100%;
  bottom: 15vh;
  left: 55%;
  transform: translate(-50%, 0);
}
</style>
